/** Logo officiel LyrraOne (icône + texte) — `public/Logo LyrraOne.png` */
export const LYRRAONE_LOGO_SRC = '/Logo%20LyrraOne.png';

/** Icône seule — `public/logo small.png` (menu réduit, favicon, etc.) */
export const LYRRAONE_LOGO_ICON_SRC = '/logo%20small.png';

export const LYRRAONE_LOGO_ALT = 'LyrraOne — plateforme formation en ligne francophone';

export const LYRRAONE_LOGO_ICON_ALT = 'LyrraOne';
